// test946
(946 && 0);
